module.exports = __webpack_public_path__ + "static/media/why3.ebd1c576.png";